export const LANDING_MD_MEDIA_QUERY = '(min-width: 768px)'

const HAVE_METADATA = 1

export type DemoPlaybackMedia = {
    paused: boolean
    ended: boolean
    currentTime: number
    readyState: number
    pause: () => void
    play: () => Promise<unknown>
    addEventListener: (type: 'loadedmetadata', listener: () => void, options?: { once?: boolean }) => void
}

export type DemoPlaybackCursor = {
    time: number
    playing: boolean
}

const resumeToken = new WeakMap<DemoPlaybackMedia, number>()

function bumpResumeToken(video: DemoPlaybackMedia) {
    const next = (resumeToken.get(video) ?? 0) + 1
    resumeToken.set(video, next)
    return next
}

export function readDemoPlaybackCursor(video: DemoPlaybackMedia): DemoPlaybackCursor {
    return {
        time: video.currentTime,
        playing: !video.paused && !video.ended,
    }
}

export function applyDemoPlaybackCursor(video: DemoPlaybackMedia, cursor: DemoPlaybackCursor) {
    const token = bumpResumeToken(video)
    const apply = () => {
        if (resumeToken.get(video) !== token) return
        video.currentTime = cursor.time
        if (cursor.playing) video.play().catch(() => undefined)
    }

    if (video.readyState >= HAVE_METADATA) {
        apply()
        return
    }

    video.addEventListener('loadedmetadata', apply, { once: true })
}
